import React, { useEffect, useState } from "react";
import Testdetails from "../../assets/Icons/testdetails.svg";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import Home from "../../assets/Icons/Home.svg";
import Lab from "../../assets/Icons/biotech.svg";
import injection from "../../assets/Icons/syringe.svg";
import Unisex from "../../assets/Icons/unisex.svg";
import Prescriptions from "../../assets/Icons/requred.svg";
import Reports from "../../assets/Icons/Report.svg";
import Age from "../../assets/Icons/personage.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  createCartOrderDtlItem,
  createCartOrderHdrItem,
  getCurrentTime,
} from "../../Shared/CartHelper";
import { useLocation } from "react-router-dom";
import { AddtoCart, getCartDetails } from "../../Redux/actions/cartActions";
import LocationService from "../../Services/LocationService";
import Layout from "../../Layout";
import { message, Modal } from "antd";
import { convertUTCDate } from "../../utils/convertionFunc";
import PatientService from "../../Services/PatientService";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";

function TestDetails() {
  const [isTestThereInCart, setIsTestThereInCart] = useState(false);
  const [address, setAddress] = useState(null);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [addressModButton, setAddressModButton] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    mobile: "",
    pinCode: "",
    state: "",
  });
  const [patientMembershipDet, setPatientMembershipDet] = useState(null);
  const location = useLocation();
  const labTestObj = location.state?.labTest;
  const dispatch = useDispatch();
  const { cartData } = useSelector((state) => state.cart);
  const { states, countries } = useSelector((state) => state.common);
  const { patientData } = useSelector((state) => state.auth);
  const match = labTestObj?.testDisplayName.match(/\(([^)]+)\)/);
  const testsArr = match ? match[1].split(",").map((test) => test.trim()) : [];
  const CURRENCYCODE = process.env.REACT_APP_CURRENCYCODE || "";

  useEffect(() => {
    if (!cartData) return;
    const { cartOrderHdr } = cartData;
    const labData = cartOrderHdr?.find((item) => item.orderType === "LAB");
    if (labData) {
      const labItems = labData?.cartOrderDtl;
      if (labItems && labItems?.length !== 0) {
        const isLabTestThereInCart = labItems?.find(
          (item) => item.orderCode === labTestObj.testCode
        );
        if (isLabTestThereInCart) {
          setIsTestThereInCart(true);
        }
      }
    }
  }, [cartData]);

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      fetchPatientAddress();
      fetchMembershipDetails();
      dispatch(getCartDetails({ patientId: patientData.patientId }));
    }
  }, [patientData]);

  useEffect(() => {
    if (isAddressModalOpen && patientData && patientData?.patientId) {
      setFormData({
        firstName: patientData?.firstName + patientData?.lastName,
        address1: patientData?.address1,
        address2: patientData?.address2,
        city: patientData?.city,
        country: patientData?.country,
        mobile: patientData?.mobile,
        pinCode: patientData?.pinCode,
        state: patientData?.state,
      });
    }
  }, [isAddressModalOpen]);

  // useEffect(() => {
  //   if (patientMembershipDet) {
  //     const currentPrice = labTestObj?.listPrice || 0;
  //     const discountAmount = Math.floor(currentPrice * (patientMembershipDet?.discountPercentage / 100));
  //     setDiscountAmt(discountAmount);
  //     const finalDoctorFee = currentPrice - discountAmount;
  //     setDiscountedPrice(finalDoctorFee);
  //   }
  // }, [labTestObj?.listPrice, patientMembershipDet]);

  const calculateDiscountedPrice = (labTest, patientMembershipDet) => {
    const currentPrice = Number(labTest?.listPrice) || 0;
    if (!patientMembershipDet) return currentPrice.toFixed(2);
    const discountPercent = Number(patientMembershipDet?.discountPercentage) || 0;
    const discountAmount = Math.floor(
      currentPrice * (discountPercent / 100)
    );
    const finalMedPrice = currentPrice - discountAmount;
    return finalMedPrice?.toFixed(2);
  };

  const calculateDiscountAmount = (labTest, patientMembershipDet) => {
    if (!patientMembershipDet) return 0;
    const currentPrice = Number(labTest?.listPrice) || 0;
    const discountPercent = Number(patientMembershipDet?.discountPercentage) || 0;
    const discountAmount = Math.floor(
      currentPrice * (discountPercent / 100)
    );
    return discountAmount;
  };

  const fetchMembershipDetails = async () => {
    const payload = {
      // patientId: patientData?.patientId,
      membershipCard: patientData?.membershipCard,
      serviceCategory:
        labTestObj?.category ||
        labTestObj?.testType?.toUpperCase() ||
        "PATHOLOGY",
    };

    try {
      const response = await PatientService.patientMembershipDet(payload);
      setPatientMembershipDet(response?.data?.data?.[0] || null);
    } catch (e) {
      console.error(e);
    }
  };

  const handleAdrrsFormClose = () => {
    setIsAddressModalOpen(false);
    setFormData({
      firstName: "",
      address1: "",
      address2: "",
      city: "",
      country: "",
      mobile: "",
      pinCode: "",
      state: "",
    });
  };

  const fetchPatientAddress = async () => {
    let payload = {
      patientId: patientData.patientId,
      status: 1,
      defaultAddressYN: "Y",
    };
    try {
      let result = await LocationService.getPatientAddress(payload);
      if (result.data.length > 0) {
        setAddress(result.data?.[0] || null);
      } else {
        setAddressModButton(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const AccordionItem = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="border rounded-md mb-2">
        <button
          className="w-full text-left p-4 flex justify-between rounded-md items-center bg-white shadow-md hover:bg-gray-50"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="font-semibold">{title}</span>
          {isOpen ? <AiOutlineUp size={18} /> : <AiOutlineDown size={18} />}
        </button>
        {isOpen && (
          <div className="p-4 bg-white text-sm font-sans font-medium text-[#333333] h-[450px] overflow-y-scroll scrollWidth">
            {content}
          </div>
        )}
      </div>
    );
  };

  const items = [
    {
      title: (
        <>
          <span className="font-bold font-sans text-base">
            {labTestObj?.testDisplayName}
          </span>
          <br />
          <span className="text-sm font-sans font-semibold text-[#189FAA]">
            {labTestObj?.noOfTestIncluded > 0 &&
              `${labTestObj?.noOfTestIncluded} Tests included`}
          </span>
        </>
      ),
      content: (
        <ul className="list-disc pl-5 text-sm text-gray-700">
          {testsArr.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      ),
    },
  ];

  const handleAddToCart = async ({ itemObj, type }) => {
    if (!patientData && patientData?.patientId) {
      message.error("login");
      return;
    }

    if (!itemObj) return;


    const now = getCurrentTime();
    const existingCartId = cartData?.cartId;
    const cartHdrs = [...(cartData?.cartOrderHdr || [])];
    const itemCode = itemObj.testCode;
    const itemName = itemObj.testName;
    const itemCategory = itemObj?.category || itemObj?.testType?.toUpperCase();
    const vendorId = itemObj.labCode;
    const price = parseFloat(itemObj.listPrice || 0);

    const existingHdr = cartHdrs.find((hdr) => hdr.orderType === type);
    let payload;

    if (!existingCartId) {
      // No cart – create new
      const dtlItem = createCartOrderDtlItem({
        item: {
          code: itemCode,
          name: itemName,
          labCategory: itemCategory,
          price,
          vendorId,
        },
        type,
        patientId: patientData.patientId,
        user: patientData,
      });

      payload = {
        cartOrderHdr: [
          createCartOrderHdrItem({
            Acc_branch: { acc_Id: itemObj.labCode, bran_Id: itemObj.branchId },
            dtlItem,
            account: address || null,
            user: patientData,
            patientId: patientData.patientId,
            type,
          }),
        ],
        cartType: 1,
        patientId: patientData.patientId,
        paymentType: "",
        status: 1,
      };
      payload.cartOrderHdr[0].labCategory = "External Lab Test";

      let grandTotalAmount = payload?.cartOrderHdr?.reduce((sum, order) => {
        return sum + (Number(order?.paidAmount) || 0);
      }, 0);

      payload = {
        ...payload,
        totalAmount: grandTotalAmount,
      };
    } else {
      // Update existing cart
      const newHdrs = cartHdrs.map((hdr) => {
        if (hdr.orderType !== type) return hdr;

        const existingItem = hdr.cartOrderDtl.find(
          (i) => i.orderCode === itemCode
        );
        let updatedDtl = [...hdr.cartOrderDtl];
        if (existingItem) {
          updatedDtl = updatedDtl.map((i) =>
            i.orderCode === itemCode
              ? {
                ...i,
                quantity: i.quantity + 1,
                amount: (i.quantity + 1) * i.unitPrice,
                paidAmount: (i.quantity + 1) * i.unitPrice,
                modifiedDate: now,
                orderState: "U",
              }
              : i
          );
        } else {
          const newDtlItem = createCartOrderDtlItem({
            item: {
              code: itemCode,
              name: itemName,
              labCategory: itemCategory,
              price,
              vendorId,
            },
            type,
            patientId: patientData.patientId,
            user: patientData,
            cartId: existingCartId,
          });
          updatedDtl.push(newDtlItem);
        }

        const totalAmt = updatedDtl.reduce(
          (sum, i) => sum + Number(i.amount),
          0
        );
        const totalPaid = updatedDtl.reduce(
          (sum, i) => sum + Number(i.paidAmount),
          0
        );

        return {
          ...hdr,
          cartOrderDtl: updatedDtl,
          amount: Number(parseFloat(totalAmt).toFixed(2)),
          paidAmount: Number(parseFloat(totalPaid).toFixed(2)),
          modifiedDate: now,
        };
      });

      // If this type doesn't exist yet, add it
      if (!existingHdr) {
        const dtlItem = createCartOrderDtlItem({
          item: {
            code: itemCode,
            name: itemName,
            labCategory: itemCategory,
            price,
            vendorId,
          },
          type,
          patientId: patientData.patientId,
          user: patientData,
          cartId: existingCartId,
        });

        const cartHdrObject = createCartOrderHdrItem({
          Acc_branch: { acc_Id: itemObj.labCode, bran_Id: itemObj.branchId },
          dtlItem,
          account: address || null,
          user: patientData,
          patientId: patientData.patientId,
          type,
        });
        cartHdrObject.labCategory = "External Lab Test";
        newHdrs.push(cartHdrObject);
      }

      let grandTotalAmount = newHdrs?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);

      payload = {
        ...cartData,
        cartId: existingCartId,
        cartOrderHdr: newHdrs,
        modifiedDate: now,
        totalAmount: grandTotalAmount,
      };
    }

    try {
      const updatedCart = await dispatch(AddtoCart(payload));
      // dispatch(updateCartState(updatedCart.data));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      message.success("LabTest added to cart successfully.");
    } catch (e) {
      console.error(e);
    }
  };

  const handleNewAddress = () => {
    setIsAddressModalOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddressSave = async (e) => {
    e.preventDefault();
    const isFormEmpty = Object.values(formData).every(
      (value) => value.trim() === ""
    );

    if (isFormEmpty) {
      message.error("Please enter values in the form");
      return;
    }

    let payload = {
      account_Id: patientData.account_Id,
      clinic_Id: patientData.clinic_Id,
      createdBy: patientData.patientId,
      modifiedBy: patientData.patientId,
      patientId: patientData.patientId,
      defaultAddressYN: "Y",
      status: 1,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      ...formData,
    };
    try {
      await LocationService.savePatientAddress(payload);
      setAddressModButton(false);
      setIsAddressModalOpen(false);
      fetchPatientAddress();
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  return (
    <Layout>
      <div className="p-5">
        <div className="w-full flex justify-between">
          <div className="w-[75%] flex gap-2 items-center">
            <h3 className="w-36 text-[#189FAA] font-sans font-semibold text-sm">
              Book Lab Test
            </h3>
            <p>/</p>
            <h3 className="font-sans font-semibold text-sm text-[#232323]">
              {labTestObj?.testDisplayName}
            </h3>
          </div>
          {/* <div className="w-[10%]">
            {addressModButton && (
              <h3
                className="font-sans underline cursor-pointer font-semibold text-sm text-[#189FAA]"
                onClick={handleNewAddress}
              >
                Add address
              </h3>
            )}
          </div> */}
        </div>

        <div className="w-[90%] m-auto mt-5">
          <div className="flex gap-3 w-full">
            <div className="space-y-6 w-[60%]">
              <div className="flex flex-col md:flex-row md:justify-between border rounded-lg p-4 shadow-sm">
                <div className="md:w-1/2">
                  <h1 className="font-bold text-base font-sans ">
                    {labTestObj?.testDisplayName}
                  </h1>
                  <p className="text-sm text-[#189FAA] font-sans font-medium mt-2">
                    {labTestObj?.noOfTestIncluded > 0 &&
                      `${labTestObj?.noOfTestIncluded} Tests included`}
                  </p>

                  {patientMembershipDet ? (
                    <div className="flex items-center gap-2 my-2">
                      {/* <div
                      className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${patientMembershipDet?.membershipCode === "SINGLE"
                        ? "from-[#81CAF4] to-[#58B4E9]"
                        : patientMembershipDet?.membershipCode === "TWIN"
                          ? "from-[#5DEB6D] to-[#34CF47]"
                          : patientMembershipDet?.membershipCode === "FAMILY" ? "from-[#35D9D4] to-[#1DBBB6]" : ''
                        }`}
                    >
                      <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                        <span className="font-medium text-sm">
                          {patientMembershipDet?.membershipCode === "SINGLE"
                            ? "Single member"
                            : patientMembershipDet?.membershipCode === "TWIN"
                              ? "Twin members"
                              : patientMembershipDet?.membershipCode === "FAMILY" ? "Family" : ''}
                        </span>
                        <span className="text-xs font-normal text-gray-500">Membership</span>
                      </p>
                    </div> */}

                      <div className="flex items-center gap-1">
                        <span className="text-lg font-sans font-semibold text-[#333333]">
                          <span className="text-sm font-normal text-gray-400 mr-0.5">
                            {`${CURRENCYCODE} `}
                          </span>
                          {calculateDiscountedPrice(
                            labTestObj,
                            patientMembershipDet
                          )}
                        </span>
                        <span className="line-through text-[#738483] font-opensans text-base">
                          {labTestObj?.listPrice}
                        </span>
                        <span className="text-[#117F0D]">
                          (Save {`${CURRENCYCODE} `}
                          {calculateDiscountAmount(
                            labTestObj,
                            patientMembershipDet
                          ) || "-"}
                          )
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="text-xl font-bold text-[#333333] font-sans mt-2">
                      <span className="text-sm font-normal text-gray-400 mr-0.5">
                        {`${CURRENCYCODE} `}
                      </span>{" "}
                      {labTestObj?.listPrice}/-
                    </div>
                  )}
                  <div className="flex space-x-2 mt-3">
                    <span className="text-xs flex gap-2 items-center font-sans font-medium bg-[#EFFBFF] border-[#B9EFFF] border text-[#333333] px-2 py-1 rounded">
                      <img src={Home} alt="" /> Home Sample Collection
                    </span>
                    <span className="text-xs flex gap-2 items-center bg-purple-100 text-[#333333] font-sans font-medium px-2 py-1 rounded">
                      <img src={Lab} alt="" /> Lab Centre Visit
                    </span>
                  </div>
                  {/* <div className="flex items-center gap-2 space-x-2 mt-3">
                  <p className="font-light text-sm">Preferred Date :</p>
                  <DatePicker/>
                </div> */}
                  <div className="mt-6">
                    <button
                      disabled={isTestThereInCart}
                      className=" bg-[#189FAA] text-white px-10 py-1 font-sans font-semibold text-sm rounded hover:bg-teal-700 disabled:bg-brand-successColor"
                      onClick={() =>
                        handleAddToCart({
                          itemObj: labTestObj,
                          type: "LAB",
                        })
                      }
                    >
                      {isTestThereInCart ? "Added" : "Add to cart"}
                    </button>
                  </div>
                </div>
                <div className="md:w-1/3">
                  <img src={Testdetails} alt="" />
                </div>
              </div>

              <div className="border rounded-lg p-4 shadow-sm space-y-4">
                <h2 className="font-bold text-base text-[#333333] font-sans">
                  About the Test
                </h2>
                <div className="flex gap-4 text-sm text-gray-600">
                  <div className="flex gap-2 items-center">
                    <img src={injection} alt="" className="w-7 h-7" />
                    <div className="space-y-1">
                      <p className="text-sm font-sans font-semibold text-[#18A0AA]">
                        Sample Type
                      </p>
                      <p className="text-[#333333] text-sm font-sans font-semibold">
                        {labTestObj.specimen}
                      </p>
                    </div>
                  </div>
                  <p className="border-r-2"></p>
                  <div className="flex gap-2 items-center">
                    <img src={Unisex} alt="" className="w-6 h-6" />
                    <div className="space-y-1">
                      <p className="text-sm font-sans font-semibold text-[#189FAA]">
                        Gender
                      </p>
                      <p className="text-[#333333] text-sm font-sans font-semibold">
                        Unisex
                      </p>
                    </div>
                  </div>
                  <p className="border-r-2"></p>
                  <div className="flex gap-2 items-center">
                    <img src={Age} alt="" className="w-7 h-7" />
                    <div className="space-y-1">
                      <p className="text-sm font-sans font-semibold text-[#189FAA]">
                        Age Group
                      </p>
                      <p className="text-[#333333] text-sm font-sans font-semibold">
                        All age groups
                      </p>
                    </div>
                  </div>
                  <p className="border-r-2"></p>
                  <div className="flex gap-2 items-center">
                    <img src={Prescriptions} alt="" className="w-6 h-6" />
                    <div className="space-y-1">
                      <p className="text-sm font-sans font-semibold text-[#18A0AA]">
                        Prescriptions
                      </p>
                      <p className="text-[#333333] text-sm font-sans font-semibold">
                        Not Required
                      </p>
                    </div>
                  </div>
                  <p className="border-r-2"></p>
                  <div className="flex gap-2 items-center">
                    <img src={Reports} alt="" className="w-4 h-4" />
                    <div className="space-y-1">
                      <p className="text-sm font-sans font-semibold text-[#18A0AA]">
                        Reports
                      </p>
                      <p className="text-[#333333] text-sm font-sans font-semibold">
                        {labTestObj?.tat}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <h3 className="font-bold text-base text-[#333333] font-sans">
                    Prerequisites
                  </h3>
                  <p className="text-sm text-[#333333] font-sans font-medium mt-2">
                    {labTestObj?.preTestInfo}
                  </p>
                </div>
                <div className="mt-5">
                  <h3 className="font-bold text-base text-[#333333] font-sans">
                    Overview
                  </h3>
                  <p className="text-sm text-[#333333] font-sans font-medium mt-2">
                    {labTestObj?.testOverview}
                  </p>
                </div>
              </div>
            </div>

            {/* Accordion Column */}
            <div className="w-[40%]">
              {items.map((item, idx) => (
                <AccordionItem
                  key={idx}
                  title={item.title}
                  content={item.content}
                  className
                />
              ))}
            </div>
          </div>
        </div>

        {/* Add new address */}
        <Modal
          title={
            <span className="text-sm font-semibold font-sans text-[#189FAA]">
              Add Address
            </span>
          }
          open={isAddressModalOpen}
          onCancel={handleAdrrsFormClose}
          footer={[]}
          destroyOnClose
        >
          <form className="space-y-4 mt-3">
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Name"
                name="firstName"
                disabled={true}
                value={formData.firstName || ""}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Mobile Number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Pin Code"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <select
                value={formData.state}
                onChange={handleChange}
                name="state"
                className="w-full py-2 px-3 border rounded text-xs text-gray-400 font-sans  outline-none"
              >
                <option value="" disabled>
                  Select State
                </option>
                {states.map((state) => (
                  <option key={state.stateId} value={state.stateId}>
                    {state.stateName}
                  </option>
                ))}
              </select>
              <select
                value={formData.country}
                onChange={handleChange}
                name="country"
                className="w-full px-3 py-2 border rounded font-sans text-gray-400  text-xs outline-none"
              >
                <option value="" disabled>
                  Select Country
                </option>
                {countries.map((country) => (
                  <option key={country.country_Id} value={country.country_Id}>
                    {country.country_Name}
                  </option>
                ))}
              </select>
            </div>
            <textarea
              placeholder="Full Address"
              rows="3"
              value={formData.address1}
              name="address1"
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
            />

            <div className="flex justify-end gap-4 mt-4">
              <button
                type="button"
                onClick={handleAdrrsFormClose}
                className="px-4 py-1 border border-cyan-600 font-sans text-sm font-medium text-cyan-600 rounded"
              >
                Cancel
              </button>
              <button
                className="px-4 py-1 bg-[#189FAA] font-sans text-sm text-white font-semibold rounded"
                onClick={handleAddressSave}
              >
                Save Address
              </button>
            </div>
          </form>
        </Modal>
      </div>
    </Layout>
  );
}

export default TestDetails;
